/**
 * @desc 创建订阅测试
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, body: defs.walmart.EventsBean, options?: any) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/testSubscriptions/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
